// 9fbef606107a605d69c0edbcd8029e5d
import { createSelector } from 'reselect';

export const getAddressListState = (state) => {
  return state.AddressBookReducer && state.AddressBookReducer.get('list');
};

export const getPreferredAddress = createSelector(getAddressListState, (addressList) => {
  return addressList ? addressList?.find((address) => address?.preferred === 'true') : null;
});

export const getAddressListFetchingState = (state) => {
  return state.AddressBookReducer && state.AddressBookReducer.get('isFetching');
};

export const showUpdatedNotificationState = (state) => {
  return state.AddressBookReducer && state.AddressBookReducer.get('showUpdatedNotification');
};

export const showUpdatedNotificationOnModalState = (state) => {
  return state.AddressBookReducer && state.AddressBookReducer.get('showUpdatedNotificationOnModal');
};

export const deleteModalOpenState = (state) => {
  return state.AddressBookReducer && state.AddressBookReducer.get('deleteModalMountedState');
};
